export const firebaseImage = {
    microphonePermissionModal: "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/picture%2Factivity-submissions%2F2025-12-18-745e394e-a2d6-4546-becc-f995264dd16caudio-permission-image.png?alt=media&token=e635889b-54d3-4b88-b02b-488c4083ff28"
}